import React from 'react';
import { useMediaQuery } from 'react-responsive';
import '../styles/components/ResponsiveLayout.css';
import NavBar from './common/NavBar';
import Footer from './common/Footer';

const ResponsiveLayout = ({ children, hasNavbar, hasFooter, backgroundColor }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
  const isTablet = useMediaQuery({ query: '(min-width: 601px) and (max-width: 1024px)' });
  const isDesktop = useMediaQuery({ query: '(min-width: 1025px)' });
  const style = {
    backgroundColor,
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column"
  };
  return (
    <div className={`responsive-layout ${isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'}`} style={style}>
      {hasNavbar && <NavBar />}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </div>
      {hasFooter && <Footer />}
    </div>
  );
};

export default ResponsiveLayout;
